// Helper: wait for Searchspring element
function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(selector)) {
      resolve();
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Timeout waiting for: ${selector}`));
    }, timeout);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Only run if Searchspring container exists on the page
  if (document.getElementById('searchspring-content')) {
    console.log("Page loaded — waiting for Searchspring...");
    runAfterSearchspring();
  } else {
    // Searchspring not on this page, run Regios immediately
    waitForRegios();
  }
});

async function runAfterSearchspring() {
  try {
    await waitForElement('.ss__result__details'); // ⬅️ Change selector if needed
    console.log("Searchspring elements detected");

    waitForRegios();
  } catch (e) {
    console.warn("Searchspring element not found, proceeding with Regios:", e.message);
    // Still run Regios even if Searchspring element isn't found
    waitForRegios();
  }
}

function waitForRegios() {
  const runRegiosScript = (api) => {
    console.log("Regios DOPP API initialized", { api });
    applyRegiosDiscount(api); // your logic
  };

  if (window.RegiosDOPP?.api?.v0) {
    runRegiosScript(window.RegiosDOPP.api.v0);
  } else {
    window.addEventListener("regios-dopp:api-initialized", (e) => {
      runRegiosScript(e.detail.api);
    });
  }
}

function applyRegiosDiscount(api) {
  console.log("Running Regios discount logic…");

  // Example:
  // api.cart.setDiscount({ percent: 10 });
}